import i18n from "@/i18n";

export const tx = (key, opts) => i18n.t(key, opts);
